import { FC, ReactNode } from 'react';
import cn from 'classnames';
import styles from '../navheader.module.scss';
import { CloseIcon } from '@/assets/icons/CloseIcon';
import { Text } from '@/ui-components/atoms/Text/Text';

interface SearchBarContainerProps {
    searchOpen: boolean;
    handleSearchClose: () => void;
    searchBar: ReactNode;
    localpagename: string;
}

const SearchBarContainer: FC<SearchBarContainerProps> = ({
    searchOpen,
    handleSearchClose,
    searchBar,
    localpagename = '',
}) => {
    return (
        <div
            data-searchstatus={searchOpen}
            className={cn(styles.searchContainer, { [styles.searchOpen]: searchOpen })}
            role="dialog"
            aria-modal={true}
            aria-label="Search"
            data-localpagename={localpagename}
        >
            <div className={styles.searchMobileTop}>
                <Text tag="p" variant="h5" className={styles.searchMobileTopHeading}>
                    Search
                </Text>
                <button
                    className={styles.searchMobileCloseButton}
                    onClick={handleSearchClose}
                    aria-label="Close search"
                >
                    <CloseIcon aria-hidden="true" />
                </button>
            </div>
            {searchBar}
        </div>
    );
};

export default SearchBarContainer;
